const blacklist = {
    wordEn: '',
    wordDe: '',
};

export const formInitialValues = {
    blacklist,
};
